import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from 'src/app/_services/toaster.service';
import { UserService } from 'src/app/_services/generatedServices';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ImageViewModel, UpdateProfileViewModel } from 'src/app/_models/generatedModels';
import { Title } from '@angular/platform-browser';
import { ValidatorHelper } from 'src/app/_helpers/validationHelper';
import { SettingsProvider } from 'src/app/_services/settingsProvider.service';
import * as customBuild from 'src/ckCustomBuild/ckeditor';


@Component({
  selector: 'bxl-profile',
  templateUrl: 'profile.component.html',
})
export class ProfileComponent implements OnInit, OnDestroy {
  initialized = false;
  submitComplete: Promise<{}> | undefined;
  public formGroup: FormGroup;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  initialCroppedImage: string;
  modalImage: any;

  public Editor:any = customBuild;

  htmlEditorConfig = {
    toolbar: {
      items: ['bold', 'italic', 'underline', 'link', 'alignment','outdent','indent', 'bulletedList', 'numberedList', '|', 'fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor','SourceEditing'],
      shouldNotGroupWhenFull: false,
    },
    fontSize: {
      options: [9, 11, 13, 'default', 17, 19, 21]
    },
    mediaEmbed: {
      previewsInData: true,
    },
  };

  constructor(private route: ActivatedRoute, public settings: SettingsProvider, private router: Router, private validatorHelper: ValidatorHelper, private toastr: ToasterService, public auth: AuthenticationService, private userService: UserService, private modalService: NgbModal, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.auth.fetchUserProfile().subscribe((result) => {
      console.log(result.avatar);
      if (result.avatar) {
        this.userService.getImageAsBase64().subscribe((image) => {
          this.croppedImage = image.value;
          this.initialCroppedImage = image.value;
          this.setupForm();
        });
      } else {
        this.setupForm();
      }
    });
  }

  editImage(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg', backdrop: 'static' }).result.then(
      (result) => {
        this.croppedImage = this.modalImage;
        console.log('here');
      },
      (reason) => {
        console.log('here2');
      }
    );
  }

  setupForm(): any {
    this.formGroup = this.fb.group({
      firstName: [this.auth.user.firstName, [Validators.required]],
      credentials: [this.auth.user.credentials],
      biography: [this.auth.user.biography],
      lastName: [this.auth.user.lastName, [Validators.required]],
      email: [this.auth.user.email, [Validators.required, Validators.email], [this.validatorHelper.validateEmailNotTaken(this.auth.user.id)]],
      alternateEmail: [this.auth.user.alternateEmail, [Validators.email]],
      phoneNumber: [this.auth.user.phoneNumber],
      affiliation: [this.auth.user.affiliation],
      pronouns: [this.auth.user.pronouns],
      certificantNumber: [this.auth.user.certificantNumber],
      flMhPsychCertificantNumber: [this.auth.user.flMhPsychCertificantNumber],
    });

    this.initialized = true;
  }

  public onSave() {
    console.log(this.formGroup?.controls['email'].errors && this.formGroup?.controls['email'].errors);
    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      this.toastr.error('Please fill out all required fields', 'Error');
      return;
    }

    this.submitComplete = new Promise((resetButton: any, reject) => {
      const formData: UpdateProfileViewModel = Object.assign({}, this.auth.user, this.formGroup.value);

      if (this.initialCroppedImage !== this.croppedImage) {
        formData.base64Image = this.croppedImage;
      } else {
        formData.base64Image = null;
      }

      this.update(formData, resetButton);
    });
  }

  update(formData: UpdateProfileViewModel, resetButton: () => any) {
    this.userService.updateProfile(formData).subscribe(
      (user) => {
        this.auth.user = user;
        this.navigateBack();
        this.toastr.success('Profile Updated', 'Success');
        resetButton();
      },
      (error) => resetButton()
    );
  }

  navigateBack() {
    this.router.navigate(['.'], { relativeTo: this.route.parent });
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.modalImage = event.base64;
    console.log(this.initialCroppedImage === this.croppedImage);
  }

  imageLoaded() {
    console.log('loaded');
    // show cropper
  }

  loadImageFailed() {
    // show message
  }

  removeImage(index) {
    (<FormArray>this.formGroup.controls['images']).removeAt(index);
    console.log(index);
  }

  onSelectFile(files) {
    if (files && files[0]) {
      let filesAmount = files.length;
      for (let i = 0; i < filesAmount; i++) {
        let reader = new FileReader();

        reader.onload = (onloadEvent: any) => {
          const control = <FormArray>this.formGroup.controls['images'];
          let image = new ImageViewModel();
          image.base64File = onloadEvent.target.result;
          image.isPrimary = false;
          control.push(new FormControl(image));
        };

        reader.readAsDataURL(files[i]);
      }
    }
  }

  ngOnDestroy() {}
}
